import { Link } from 'wouter';
import svgPaths from '../imports/svg-hce880aog5';

function Group1() {
  return (
    <div className="absolute inset-[5.52%_1.35%_3.37%_1.51%]" data-name="Group">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 103 52">
        <g id="Group">
          <g id="Group_2">
            <path d={svgPaths.pce01f00} fill="#C65328" id="Vector" />
            <path d={svgPaths.p245b0400} fill="#C65328" id="Vector_2" />
            <path d={svgPaths.p36c05500} fill="#C65328" id="Vector_3" />
            <path d={svgPaths.p12934600} fill="#C65328" id="Vector_4" />
            <path d={svgPaths.p3c823b00} fill="#C65328" id="Vector_5" />
          </g>
          <path d={svgPaths.p22b47f00} fill="#C65328" id="Vector_6" />
          <g id="Group_3">
            <path d={svgPaths.p36e92900} fill="#C65328" id="Vector_7" />
            <path d={svgPaths.p3b903e00} fill="#C65328" id="Vector_8" />
            <path d={svgPaths.p1166b700} fill="#C65328" id="Vector_9" />
            <path d={svgPaths.p15556e40} fill="#C65328" id="Vector_10" />
            <path d={svgPaths.p31664100} fill="#C65328" id="Vector_11" />
            <path d={svgPaths.p36b8e280} fill="#C65328" id="Vector_12" />
            <path d={svgPaths.p16053c00} fill="#C65328" id="Vector_13" />
            <path d={svgPaths.p219e8480} fill="#C65328" id="Vector_14" />
            <path d={svgPaths.p1171fc00} fill="#C65328" id="Vector_15" />
            <path d={svgPaths.p800c500} fill="#C65328" id="Vector_16" />
            <path d={svgPaths.p21d3c500} fill="#C65328" id="Vector_17" />
          </g>
          <g id="Group_4">
            <path d={svgPaths.p173c4600} fill="#4272A2" id="Vector_18" />
            <path d={svgPaths.peb64400} fill="#4272A2" id="Vector_19" />
            <path d={svgPaths.p278fbdf0} fill="#4272A2" id="Vector_20" />
          </g>
          <path d={svgPaths.p2cb7e040} fill="#E5BC21" id="Vector_21" />
        </g>
      </svg>
    </div>
  );
}

function DiLabLogo() {
  return (
    <div className="h-[56px] overflow-clip relative shrink-0 w-[105.778px]" data-name="diLab_logo">
      <div className="absolute contents inset-[5.52%_1.35%_3.37%_1.51%]" data-name="Group">
        <Group1 />
      </div>
    </div>
  );
}

function Logo() {
  return (
    <div className="flex flex-col gap-[24px] items-center md:items-start w-full md:basis-0 md:grow md:min-h-px md:min-w-px overflow-clip relative shrink-0" data-name="Logo">
      <Link href="/" aria-label="Home">
        <DiLabLogo />
      </Link>
    </div>
  );
}

function Links() {
  return (
    <div className="flex flex-col md:flex-row font-['Poppins',sans-serif] gap-[32px] items-start not-italic relative shrink-0 text-[#767778] text-nowrap whitespace-pre" data-name="Links">
      <Link href="/" className="text-[16px] tracking-[-0.08px] relative shrink-0 hover:text-[#3a3b3b] transition-colors">Home</Link>
      <Link href="/members" className="text-[16px] tracking-[-0.08px] relative shrink-0 hover:text-[#3a3b3b] transition-colors">Members</Link>
      <Link href="/publications" className="text-[16px] tracking-[-0.08px] relative shrink-0 hover:text-[#3a3b3b] transition-colors">Publications</Link>
      <Link href="/news" className="text-[16px] tracking-[-0.08px] relative shrink-0 hover:text-[#3a3b3b] transition-colors">News</Link>
      <Link href="/contact" className="text-[16px] tracking-[-0.08px] relative shrink-0 hover:text-[#3a3b3b] transition-colors">Contact</Link>
    </div>
  );
}

function VuesaxLinearInstagram() {
  return (
    <a 
      href="https://instagram.com" 
      target="_blank" 
      rel="noopener noreferrer"
      className="relative shrink-0 size-[20px] cursor-pointer hover:opacity-70 transition-opacity" 
      data-name="vuesax/linear/instagram"
      aria-label="Follow us on Instagram"
    >
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <title>Instagram</title>
        <g id="instagram">
          <path d={svgPaths.p1e16c800} id="Vector" stroke="#3A3B3B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          <path d={svgPaths.pa3d6470} id="Vector_3" stroke="#3A3B3B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
          <path d="M14.6968 5.83333H14.7064" id="Vector_4" stroke="#3A3B3B" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </g>
      </svg>
    </a>
  );
}

function VuesaxLinearSms() {
  return (
    <Link href="/contact" aria-label="Send us a message" className="relative shrink-0 size-[20px] cursor-pointer hover:opacity-70 transition-opacity" data-name="vuesax/linear/sms">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <title>Email</title>
        <g id="sms">
          <path d={svgPaths.p292a9000} id="Vector" stroke="#3A3B3B" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" />
          <path d={svgPaths.p29f6ce40} id="Vector_2" stroke="#3A3B3B" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" />
        </g>
      </svg>
    </Link>
  );
}

function VuesaxLinearLocation() {
  return (
    <Link href="/contact" aria-label="View our location" className="relative shrink-0 size-[20px] cursor-pointer hover:opacity-70 transition-opacity" data-name="vuesax/linear/location">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <title>Location</title>
        <g id="location">
          <path d={svgPaths.p1594e180} id="Vector" stroke="#3A3B3B" strokeWidth="1.5" />
          <path d={svgPaths.p3d335d00} id="Vector_2" stroke="#3A3B3B" strokeWidth="1.5" />
        </g>
      </svg>
    </Link>
  );
}

function SocialLinks() {
  return (
    <div className="flex gap-[8px] md:gap-[8px] items-center justify-center md:justify-end w-full md:basis-0 md:grow md:min-h-px md:min-w-px relative shrink-0" data-name="Social Links">
      <VuesaxLinearInstagram />
      <VuesaxLinearSms />
      <VuesaxLinearLocation />
    </div>
  );
}

function Content() {
  return (
    <div className="flex flex-col md:flex-row gap-[32px] md:gap-[32px] items-center md:items-center relative shrink-0 w-full max-w-[238px] md:max-w-none" data-name="Content">
      <Logo />
      <Links />
      <SocialLinks />
    </div>
  );
}

function Row() {
  return (
    <div className="content-stretch flex gap-[24px] items-start justify-center relative shrink-0" data-name="Row">
      <p className="font-['Poppins',sans-serif] leading-[1.5] not-italic relative shrink-0 text-[#767778] text-[12px] text-center tracking-[-0.06px] whitespace-pre">
        © {new Date().getFullYear()} Design Interactions Lab. All rights reserved.
      </p>
    </div>
  );
}

function Credits() {
  return (
    <div className="content-stretch flex flex-col gap-[32px] items-center relative shrink-0 w-full bg-[rgba(0,0,0,0)]" data-name="Credits">
      <div className="h-px relative shrink-0 w-full bg-[rgba(0,0,0,0)]" data-name="Divider">
        <div aria-hidden="true" className="absolute border border-[#d6e5f3] border-solid inset-0 pointer-events-none" />
      </div>
      <Row />
    </div>
  );
}

export function Footer() {
  return (
    <div className="bg-white relative w-full mt-16 md:mt-32" data-name="Footer">
      <div className="flex flex-col items-center w-full">
        <div className="box-border content-stretch flex flex-col gap-[40px] md:gap-[80px] items-center px-6 md:px-[64px] py-[40px] md:py-[80px] relative w-full max-w-7xl">
          <Content />
          <Credits />
        </div>
      </div>
    </div>
  );
}